module.exports = __webpack_public_path__ + "static/AngelaHe0-c27a2b42ac563b40bfa860fb6ec38e84.webp";